import BaseApiClient from "@/api/base-client";
class ConversationResponseApi extends BaseApiClient {
    /**
     * Fetch conversation response by conversation ID
     */
    async getConversationResponse(conversationId) {
        return this.get(`/api/conversation/${conversationId}/response`);
    }
    /**
     * Regenerate the summary
     */
    async regenerateSummary(conversationId) {
        return this.post(`/api/conversation/${conversationId}/summary/regenerate`);
    }
}
export const conversationResponseApi = new ConversationResponseApi();
